'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  An Image component
  ```jsx_example
  <Image src={avatarImage} alt="profile image" />
  ```
  When overlay style object is provided, a span element will wrap around img element.
  This is useful if you have to deal with normalizing images with different sizes
  and you don't want images get stretched in different direction due to specifying same width and height.
  ```jsx_example
  <Image src={avatarImage} alt="profile image" style={{max-width: '50px'; overflow: 'hidden'}} />
  ```
  The `onClick` prop is a callback when user click on the image.
  ```jsx_example
  <Image alt="Binary Fountain Logo" src="/img.png" onClick={() => { callback(); }} />
  ```
  The image can be `circle` or `rectangle` shaped for now. By default it is rectangle
  ```jsx_example
  <Image src={avatarImage} alt="profile image" variant="rectangle" />
  ```
 **/
var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.styles = require('./Image.scss');
    return _this;
  }

  _createClass(Image, [{
    key: 'getImgClassName',
    value: function getImgClassName() {
      var _props = this.props,
          variant = _props.variant,
          onClick = _props.onClick;

      var className = this.styles.img;
      if (variant === 'circle') {
        className = className + ' ' + this.styles.round;
      }
      if (onClick) {
        className = className + ' ' + this.styles.clickable;
      }
      return className;
    }
  }, {
    key: 'getContainerClassName',
    value: function getContainerClassName() {
      var overlay = this.props.overlay;

      var className = this.styles.img_container;
      if (overlay) {
        className = className + ' ' + this.styles.overlay;
      }
      return className;
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      var _props2 = this.props,
          src = _props2.src,
          alt = _props2.alt,
          style = _props2.style;

      return _react2.default.createElement('img', _extends({}, this.props, {
        className: this.getImgClassName(),
        onClick: this.props.onClick,
        style: style,
        src: src,
        alt: alt
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var overlay = this.props.overlay;

      var image = this.getImage();
      if (overlay) {
        return _react2.default.createElement(
          'span',
          { style: overlay, className: this.getContainerClassName() },
          image
        );
      }
      return image;
    }
  }]);

  return Image;
}(_react.Component);

Image.propTypes = {
  src: _propTypes2.default.string.isRequired,
  alt: _propTypes2.default.string,
  style: _propTypes2.default.object,
  overlay: _propTypes2.default.object,
  variant: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
Image.defaultProps = {
  alt: 'Image Placeholder',
  variant: 'rectangle',
  style: {}
};
exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Image/Image.js
// module id = 1059
// module chunks = 1